import BurgerIcon from './BurgerIcon'

export default BurgerIcon
